const host = window.location.hostname;
const isLocal = host === "localhost" || host === "127.0.0.1";

const getBackendURL = () => {
    if (isLocal) return "http://127.0.0.1:3320";
    if (window.location.protocol === "https:" || host === "sentinel.itcold.com" || host === "sentinel.o365itguys.com") {
        return ""; // Relative URL routed via Nginx /api/ reverse proxy
    }
    if (host === "10.180.80.168") return "http://10.180.80.168:3320";
    return `http://${host}:3320`;
};

export const backendURL = getBackendURL();
